import AppRouter from 'common/AppRouter';
import {
  StyledSelectedInfo,
  StyledSelectedInfoEntity
} from './GitTeamSettings.style';
import { useHistory } from 'react-router';
import SelectedCounterToggler from 'components/base/SelectedCounterToggler';

const SelectedInfo = ({
  selectedReposIds,
  selectedServicesIds,
  isSelectedOnly,
  setIsSelectedOnly
}) => {
  const history = useHistory();

  const redirectToSelectedEntity = entity => {
    setIsSelectedOnly(true);
    history.push(entity.path);
  };

  const selectedEntitiesInfo = [
    {
      path: AppRouter.REPOSITORIES.path,
      name: `Repositories`,
      count: selectedReposIds.length
    },
    {
      path: AppRouter.GIT_SERVICES.path,
      name: 'Services',
      count: selectedServicesIds.length
    }
  ];

  return (
    <StyledSelectedInfo>
      {selectedEntitiesInfo.map(entity => {
        const isCurrentPage = history.location.pathname.includes(entity.path);
        const text = `${entity.count} ${entity.name}`;

        return (
          <StyledSelectedInfoEntity key={entity.path}>
            <SelectedCounterToggler
              count={entity.count}
              text={text}
              isActive={isCurrentPage && isSelectedOnly}
              onClick={() =>
                isCurrentPage
                  ? setIsSelectedOnly(prev => !prev)
                  : redirectToSelectedEntity(entity)
              }
            />
          </StyledSelectedInfoEntity>
        );
      })}
    </StyledSelectedInfo>
  );
};

export default SelectedInfo;
